const wrapper = "_35sw1whs7ri";
const row = "_35sr1b1krek";
const heading = "_35sh18qe9i8";
const wordContainer = "_35swlw4yeo";
const wordScrollContainer = "_35sw1a81nh7";
const arrowToFacit = "_35sa1nktvx8";

export { arrowToFacit, heading, row, wordContainer, wordScrollContainer, wrapper };
import "./organism.facit-container.style.linaria.module.css";
//# sourceMappingURL=organism.facit-container.style.js.map
